import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Box,
  Link
} from '@mui/material';
import {
  Language as WebsiteIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon
} from '@mui/icons-material';
import { Resource } from '../../../types';

interface ResourceCardProps {
  resource: Resource;
  onMakeReferral: (resourceId: string) => void;
}

export const ResourceCard: React.FC<ResourceCardProps> = ({ resource, onMakeReferral }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {resource.name}
        </Typography>
        
        <Chip 
          label={resource.category}
          color="primary"
          size="small"
          sx={{ mb: 2 }}
        />

        <Typography variant="body2" paragraph>
          {resource.description}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {resource.contact && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PhoneIcon fontSize="small" color="action" />
              <Typography variant="body2">{resource.contact}</Typography>
            </Box>
          )}
          
          {resource.address && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationIcon fontSize="small" color="action" />
              <Typography variant="body2">{resource.address}</Typography>
            </Box>
          )}
          
          {resource.website && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WebsiteIcon fontSize="small" color="action" />
              <Link href={resource.website} target="_blank" variant="body2">
                Visit Website
              </Link>
            </Box>
          )}
        </Box>

        {resource.services.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Services:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {resource.services.map((service, index) => (
                <Chip
                  key={index}
                  label={service}
                  size="small"
                  variant="outlined"
                />
              ))}
            </Box>
          </Box>
        )}
      </CardContent>
      
      <CardActions>
        <Button 
          size="small" 
          color="primary"
          onClick={() => onMakeReferral(resource.id)}
        >
          Make Referral
        </Button>
        <Button size="small">View Details</Button>
      </CardActions>
    </Card>
  );
};